import { useEffect, useState } from 'react'
import { readRemoteSessionLevels } from './remoteUnlockApi'

const PROFILE_URL = '/api/agents/agent/get-profile/'
let cache = { key: null, promise: null }

/**
 * Levels the logged-in agent may FILL ('l1', 'l2', …).
 * Read from currentUser.remote_session_level when present, otherwise from the
 * profile API. Returns null while loading, [] when the agent has no access.
 */
export default function useRemoteSessionLevels(fetchJson, currentUser) {
  const fromUser = readRemoteSessionLevels(currentUser)
  const userKey = fromUser ? fromUser.join(',') : null
  const [levels, setLevels] = useState(fromUser)

  useEffect(() => {
    if (userKey !== null) { setLevels(userKey ? userKey.split(',') : []); return }
    if (!fetchJson) return
    let active = true
    const key = String(currentUser?.id ?? currentUser?.username ?? 'me')
    if (cache.key !== key || !cache.promise) {
      cache = {
        key,
        promise: fetchJson(PROFILE_URL).catch(err => { cache = { key: null, promise: null }; throw err }),
      }
    }
    cache.promise
      .then(p => { if (active) setLevels(readRemoteSessionLevels(p) || []) })
      .catch(() => { if (active) setLevels([]) })
    return () => { active = false }
  }, [fetchJson, userKey, currentUser?.id, currentUser?.username])

  return levels
}
